<template>
  <div class="content-wrap">
    <Form :bodyClass="''" :title="formTitle" @submit="submitCompanyUser">
      <div>
        <FormSelect
          v-model="formData.companyUuid"
          :name="$t('admin.user.company')"
          :options="companyOptions"
          :loading="!companyOptions"
          :disabled="templateMode === 'edit'"
          :selectable="isSelectableCompany"
          @input="handleSelect"
          required
        />
        <FormSelect
          v-if="templateMode === 'edit'"
          v-model="company.company_type"
          :name="$t('companies.companyType')"
          :options="[
            { label: this.$t('companies.companyTypeBranch'), value: 'branch' },
            { label: this.$t('companies.companyTypeIndustry'), value: 'industry' },
          ]"
          disabled
          required
        />
        <FormSelect
          v-model="formData.roles"
          :name="$t('companies.roles')"
          :options="validRoleOptions"
          :placeholder="computedPlaceholder"
          multiple
          required
        />
      </div>
      <Button type="submit" :disabled="submitDisabled" fullWidth>{{ $t('meta.save') }}</Button>
    </Form>
  </div>
</template>

<script>
import Button from '@/components/Button/index.vue'
import FormSelect from '@/components/Form/Select/index.vue'
import Form from '@/components/Form/index.vue'

import adminsApi from '@/api/admin'
import configApi from '@/api/config'
import { roleOptions, validRoles } from '@/utils/roles'

export default {
  name: 'CompanyUser',
  components: {
    Button,
    Form,
    FormSelect,
  },
  props: {
    templateMode: { type: String, required: true },
    formTitle: { type: String, required: true },
    user: { type: Object, required: true },
    companyUser: { type: Object, default: null },
  },
  data() {
    return {
      companies: null,
      company: {},
      config: null,
      formData: {
        companyUuid: null,
        roles: [],
      },
    }
  },
  computed: {
    computedPlaceholder() {
      const name = this.$t('companies.roles')
      if (!this.formData?.companyUuid) return this.$t('admin.user.chooseCompanyFirst')
      if (!this.validRoleOptions || !this.validRoleOptions.length) return this.$t('meta.noOptions', { name: name })
      return `${this.$t('meta.choose', { name: name })}`
    },
    companyOptions() {
      const mapped = this.companies?.map(company => ({ label: company.name, value: company.uuid }))
      const sorted = mapped?.sort((a, b) => a.label.localeCompare(b.label, this.$i18n.locale, { sensitivity: 'base' }))
      return sorted
    },
    validRoleOptions() {
      if (!this.company || !this.config) return
      return roleOptions(validRoles(this.company, this.config))
    },
    submitDisabled() {
      return !this.formData.companyUuid || !this.formData.roles?.length
    },
  },
  methods: {
    isSelectableCompany(option) {
      const alreadySelected = this.user?.company_users?.find(companyUser => companyUser.company_uuid === option.value)
      return !alreadySelected
    },
    submitCompanyUser() {
      this.$emit('submit', this.formData)
    },
    handleSelect(value) {
      this.company = this.companies?.find(company => company.uuid === value)
      this.formData.roles = []
    },
  },
  async created() {
    this.config = await configApi.get()
    this.companies = await adminsApi.companies.getAll()
    if (this.templateMode === 'edit') {
      this.formData.companyUuid = this.companyUser.company_uuid
      this.formData.roles = this.companyUser.roles
    }
    this.company = this.companies?.find(company => company.uuid === this.formData.companyUuid)
  },
}
</script>
